import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-rcr-exchange-error-message',
  templateUrl: './rcr-exchange-error.html',
  styleUrls: ['./rcr-exchange-error.scss'],
})
export class RcrExchangeErrorMessageComponent {
  isErrorMessage = true;
  @Input() title: string;
  @Input() description: string;
  @Input() suggestions: Array<string>;

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
